import * as Sentry from "@sentry/react-native";

Sentry.init({
  //  dsn: "https://d604b4669df6d3b0f69764c46dc003e8@o4508324435460096.ingest.de.sentry.io/4508324782669904",
});
